@if (!exportMode) {
<div class="skills-ba__edit-button-div">
  @if (editMode) {
    <button mat-raised-button
            class="skills-ba__edit-btn skills-ba__edit-btn--text"
            (click)="onCancelEdit()">
      {{ 'skills.button.cancel' | translate }}
    </button>

    <button
      mat-icon-button
      class="skills-ba__edit-btn skills-ba__edit-btn--icon"
      (click)="onCancelEdit()"
      [attr.aria-label]="'skills.button.cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <button mat-flat-button
          class="skills-ba__edit-btn skills-ba__edit-btn--text"
          [disabled]="editMode && isSaving"
          (click)="onToggleEdit()">
    {{ editMode ? ('skills.button.save' | translate) : ('skills.button.edit' | translate) }}
  </button>

  <button
    mat-icon-button
    class="skills-ba__edit-btn skills-ba__edit-btn--icon"
    [disabled]="editMode && isSaving"
    (click)="onToggleEdit()"
    [attr.aria-label]="editMode
      ? ('skills.button.save' | translate)
      : ('skills.button.edit' | translate)"
  >
    <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
  </button>
</div>
}

@if (catalog?.kenntnisse?.length) {
  <div class="skills-ba__table-scroll">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="skills-ba__skills-table"
    >
      <ng-container matColumnDef="skill">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'skills.skill' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.bezeichnung }}
        </td>
      </ng-container>

      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'skills.level' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="skills-ba__level-wrapper"
            [class.skills-ba__level-wrapper--unrated]="isUnrated(element)"
          >
            <div class="skills-ba__star-rating">
              @for (star of [1, 2, 3, 4]; track star; let i = $index) {
                <span
                  class="skills-ba__star"
                  [class.skills-ba__star--filled]="i < levelToStars(element.bewertung)"
                  (click)="editMode && setLevelByStars(element, i + 1)"
                >
                  <span class="material-icons">star</span>
                </span>
              }
            </div>

            <div class="skills-ba__level-bar-container">
              <span class="skills-ba__level-label">
                {{ 'skills.BA_LEVEL.' + levelLabel(element.bewertung) | translate }}
              </span>

              <div class="skills-ba__level-bar-bg">
                <div
                  class="skills-ba__level-bar-fill"
                  [style.width.%]="element.bewertung ? (levelToStars((element.bewertung)- 1) /3 ) * 100 : 0"
                ></div>
              </div>
            </div>

            @if (isUnrated(element)) {
              <span class="skills-ba__validation-badge">
                {{ 'skills.fieldRequired' | translate }}
              </span>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let _row; columns: displayedColumns"></tr>
    </table>
  </div>
  <!-- NP20-822: Ein Katalog hat viele Fähigkeiten; Abbrechen und Speichern kleben beim
       Bearbeiten am unteren Rand und rasten am Ende des Katalogs ein. -->
  @if (editMode && !exportMode) {
    <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
      <button mat-stroked-button type="button" (click)="onCancelEdit()">
        {{ 'skills.button.cancel' | translate }}
      </button>
      <button mat-flat-button type="button" [disabled]="isSaving" (click)="onToggleEdit()">
        {{ 'skills.button.save' | translate }}
      </button>
    </div>
  }
} @else {
  <mat-card appearance="outlined" class="skills-ba__no-skills">
    <mat-card-content>
      {{ 'skills.noSkills' | translate }}
    </mat-card-content>
  </mat-card>
}
